/**
 * 3D Custom Stabilizer Builder — playground UI + grouped cart.
 */
(function () {
  const STORAGE_KEY = "titlex_stab_playground_v1";
  const SHOW_WRAP_PICKER = true;
  const WRAP_LAUNCH_BASES = {
    marshbound: true,
    hive: true,
    pulse: true,
    topo: true,
    shattered: true,
    independence: true,
  };
  const WRAP_PLAYABLE_BASES = Object.assign({ none: true }, WRAP_LAUNCH_BASES);
  const WRAP_DEFAULT_MAX_IN = 20;
  const MICRO_LENGTHS = [8, 10, 12, 15, 18, 20];
  const PRO_LENGTHS = [10, 12, 15, 18, 24, 26, 28, 30];
  const COLORS = [
    { key: "black", label: "Black" },
    { key: "sand", label: "Sand" },
    { key: "white", label: "White" },
    { key: "od-green", label: "OD Green" },
  ];
  const WRAP_COLOR_HEX = {
    black: "#1a1a1a",
    white: "#fefefe",
    gray: "#717172",
    grey: "#717172",
    red: "#ed1c24",
    blue: "#2d2d72",
    green: "#41b656",
    pink: "#c34c9c",
    purple: "#4a2f8c",
    orange: "#f6881f",
    yellow: "#dee21d",
    teal: "#008080",
    tan: "#beaf6a",
    brown: "#8b5a2b",
    coral: "#ff7f50",
    "od green": "#4a5c32",
    "flo yellow": "#dee21d",
    "flo orange": "#f6881f",
    "flo pink": "#c34c9c",
    "flo green": "#41b656",
    "flo-yellow": "#dee21d",
    "flo-orange": "#f6881f",
    "flo-pink": "#c34c9c",
    "flo-green": "#41b656",
  };

  const defaultBar = {
    enabled: true,
    model: "micro",
    length: 12,
    color: "black",
    lynxColor: "black",
    flatsColor: "black",
    colorSplit: false,
    weightColors: [],
    included: "lynx",
    extraFlatsOz: 0,
    extraLynxOz: 0,
    qd: "0",
    endBowColor: "black",
    endTipColor: "black",
    wrapKey: "none",
    wrapUrl: null,
    wrapUv: null,
    wrapColor: null,
  };

  function defaultState(proIncluded) {
    return {
      qty: 1,
      front: { ...defaultBar, length: 12, qd: "0" },
      rear: { ...defaultBar, length: 10, qd: "rear", enabled: true },
      proIncluded: proIncluded || "lynx",
    };
  }

  function $(root, sel) {
    return root.querySelector(sel);
  }

  function lengthsFor(model) {
    return model === "pro" ? PRO_LENGTHS : MICRO_LENGTHS;
  }

  function clampLength(model, length) {
    const list = lengthsFor(model);
    const n = Number(length);
    return list.indexOf(n) >= 0 ? n : list[Math.min(2, list.length - 1)];
  }

  function includedFor(bar, proIncluded) {
    if (bar.model === "pro") return proIncluded || "lynx";
    return bar.included === "flats" ? "flats" : "lynx";
  }

  const CARBON_OZ_PER_IN = 0.27;

  function carbonOz(bar) {
    const len = Number(bar.length) || 12;
    let gel = 0;
    if (bar.model === "pro") {
      if (len >= 26) gel = 3;
      else if (len >= 18) gel = 2;
      else gel = 1;
    }
    return len * CARBON_OZ_PER_IN + gel;
  }

  function stackOz(bar, proIncluded) {
    const included = includedFor(bar, proIncluded);
    const extraFlats = Math.max(0, Number(bar.extraFlatsOz) || 0);
    const extraLynx = Math.max(0, Number(bar.extraLynxOz) || 0);
    const flats = (included === "flats" ? 3 : 0) + extraFlats;
    const lynx = (included === "lynx" ? 3 : 0) + extraLynx;
    return flats + lynx;
  }

  function qdOz(bar) {
    if (!bar.qd || bar.qd === "none") return 0;
    return bar.qd === "rear" ? 1.5 : 0.8;
  }

  function barOz(bar, proIncluded) {
    if (!bar.enabled) return 0;
    return carbonOz(bar) + stackOz(bar, proIncluded) + qdOz(bar);
  }

  function extraCharges(bar, proIncluded) {
    const included = includedFor(bar, proIncluded);
    const extraFlats = Math.max(0, Number(bar.extraFlatsOz) || 0);
    const extraLynx = Math.max(0, Number(bar.extraLynxOz) || 0);
    const lynxOnBar = (included === "lynx" ? 3 : 0) + extraLynx > 0;
    return {
      extraFlatsOz: extraFlats,
      extraLynxOz: extraLynx,
      needCap: lynxOnBar && included !== "lynx",
    };
  }

  function formatOz(n) {
    return (Math.round(n * 10) / 10).toFixed(1) + " oz";
  }

  function formatMoney(cents, moneyFormat) {
    const n = Number(cents) || 0;
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      try {
        return Shopify.formatMoney(n, moneyFormat || undefined);
      } catch (e) {
        /* fall through */
      }
    }
    return "$" + (n / 100).toFixed(2);
  }

  function parseCatalog(root) {
    const el = root.querySelector("[data-stabilizer-playground-catalog]");
    if (!el) return { moneyFormat: "${{amount}}" };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { moneyFormat: "${{amount}}" };
    }
  }

  function optionHay(v) {
    return [v.option1, v.option2, v.option3, v.title]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }

  function parseLen(v) {
    const m = optionHay(v).match(/(\d+)\s*"/);
    return m ? parseInt(m[1], 10) : null;
  }

  function matchBarVariant(product, bar, proIncluded) {
    if (!product || !product.variants) return null;
    const wantLen = clampLength(bar.model, bar.length);
    const wantColor = (bar.model === "pro" ? "black" : bar.color || "black").toLowerCase();
    const wantInc = includedFor(bar, proIncluded);
    let best = null;
    let bestScore = -1;
    product.variants.forEach(function (v) {
      const hay = optionHay(v);
      const len = parseLen(v);
      let score = 0;
      if (len === wantLen) score += 5;
      if (hay.indexOf(wantColor.replace("-", " ")) >= 0 || hay.indexOf(wantColor) >= 0) score += 2;
      if (wantInc === "lynx" && hay.indexOf("lynx") >= 0) score += 2;
      if (wantInc === "flats" && hay.indexOf("flat") >= 0) score += 2;
      if (score > bestScore) {
        bestScore = score;
        best = v;
      }
    });
    if (best && parseLen(best) === wantLen) return best;
    return (
      product.variants.find(function (v) {
        return parseLen(v) === wantLen;
      }) || product.variants[0]
    );
  }

  function matchByHay(product, needles) {
    if (!product || !product.variants) return null;
    const list = needles.map(function (n) {
      return String(n).toLowerCase();
    });
    for (let i = 0; i < product.variants.length; i++) {
      const hay = optionHay(product.variants[i]);
      if (
        list.every(function (n) {
          return hay.indexOf(n) >= 0;
        })
      ) {
        return product.variants[i];
      }
    }
    return product.variants[0] || null;
  }

  function colorLabel(key) {
    const found = COLORS.filter(function (c) {
      return c.key === key;
    })[0];
    return found ? found.label : "Black";
  }

  function validCoat(key) {
    return COLORS.some(function (c) {
      return c.key === key;
    })
      ? key
      : "black";
  }

  function stackPieces(bar) {
    const included = bar && bar.included === "flats" ? "flats" : "lynx";
    const extraFlats = Math.max(0, Number(bar && bar.extraFlatsOz) || 0);
    const extraLynx = Math.max(0, Number(bar && bar.extraLynxOz) || 0);
    const includedFlatsOz = included === "flats" ? 3 : 0;
    const includedLynxOz = included === "lynx" ? 2 : 0;
    const flatsOz = includedFlatsOz + extraFlats;
    const lynxOz = includedLynxOz + extraLynx;
    const pieces = [];
    let remainingFlats = flatsOz;
    let flatsEmitted = 0;
    // Included 3oz flats as three 1oz discs so the color rows match 3oz LynX (2 discs + cap).
    while (flatsEmitted < includedFlatsOz && remainingFlats >= 1) {
      pieces.push({ kind: "flat", oz: 1, included: true });
      flatsEmitted += 1;
      remainingFlats -= 1;
    }
    while (remainingFlats >= 2) {
      pieces.push({ kind: "flat", oz: 2, included: false });
      remainingFlats -= 2;
    }
    while (remainingFlats >= 1) {
      pieces.push({ kind: "flat", oz: 1, included: false });
      remainingFlats -= 1;
    }
    let lynxEmitted = 0;
    for (let i = 0; i < lynxOz; i++) {
      pieces.push({ kind: "lynx", oz: 1, included: lynxEmitted < includedLynxOz });
      lynxEmitted += 1;
    }
    if (lynxOz > 0) pieces.push({ kind: "cap", oz: 1, included: includedLynxOz > 0 });
    return pieces;
  }

  function stackPiecesFor(bar, proIncluded) {
    return stackPieces({
      included: includedFor(bar, proIncluded),
      extraFlatsOz: bar && bar.extraFlatsOz,
      extraLynxOz: bar && bar.extraLynxOz,
    });
  }

  function syncBarColorFromIncluded(bar, pieces) {
    if (bar.model === "pro") {
      bar.color = "black";
      return;
    }
    let first = null;
    pieces.forEach(function (piece, i) {
      if (!piece.included) return;
      const c = validCoat(bar.weightColors[i]);
      if (first == null) first = c;
    });
    if (first) bar.color = first;
  }

  function syncWeightColors(bar, proIncluded) {
    const pieces = stackPiecesFor(bar, proIncluded);
    const prev = Array.isArray(bar.weightColors) ? bar.weightColors : [];
    const lastColor = prev.length ? validCoat(prev[prev.length - 1]) : "black";
    const fill = bar.model === "pro" ? "black" : lastColor;
    const migrate = prev.length === 0 && !!(bar.lynxColor || bar.flatsColor);
    bar.weightColors = pieces.map(function (piece, i) {
      if (bar.model === "pro") return "black";
      if (prev[i]) return validCoat(prev[i]);
      if (migrate) {
        if (piece.kind === "flat") return validCoat(bar.flatsColor || fill);
        return validCoat(bar.lynxColor || fill);
      }
      return fill;
    });
    syncBarColorFromIncluded(bar, pieces);
    return pieces;
  }

  function weightColorList(bar, proIncluded) {
    const pieces = syncWeightColors(bar, proIncluded);
    return pieces
      .map(function (_piece, i) {
        return "Weight " + (i + 1) + " " + colorLabel(bar.weightColors[i] || bar.color);
      })
      .join(", ");
  }

  function swatchRow(activeKey, onPick) {
    const sw = document.createElement("div");
    sw.className = "stabilizer-playground__swatches";
    COLORS.forEach(function (c) {
      const b = document.createElement("button");
      b.type = "button";
      b.className =
        "stabilizer-playground__swatch" +
        (c.key === "white" || c.key === "sand" ? " stabilizer-playground__swatch--light" : "") +
        (activeKey === c.key ? " is-active" : "");
      b.title = c.label;
      b.setAttribute("aria-label", c.label);
      b.style.background =
        c.key === "od-green"
          ? "#4a5c32"
          : c.key === "sand"
            ? "#c4b48a"
            : c.key === "white"
              ? "#ece8e0"
              : "#1a1a1a";
      b.addEventListener("click", function () {
        onPick(c.key);
      });
      sw.appendChild(b);
    });
    return sw;
  }

  function coatRow(label, activeKey, onPick, compact) {
    const row = document.createElement("div");
    row.className =
      "stabilizer-playground__coat-row" + (compact ? " stabilizer-playground__coat-row--piece" : "");
    const lab = document.createElement("span");
    lab.className = "stabilizer-playground__coat-row-label";
    lab.textContent = label;
    row.appendChild(lab);
    row.appendChild(swatchRow(activeKey, onPick));
    return row;
  }

  function wrapManifest(root) {
    return root._stabWraps || { wraps: { none: { label: "None" } } };
  }

  function wrapLabel(manifest, key) {
    if (!key || key === "none") return "None";
    const wraps = manifest && manifest.wraps;
    const entry = wraps && wraps[key];
    if (entry && entry.label) return entry.label;
    const base = wrapBaseHandle(key);
    const baseEntry = wraps && wraps[base];
    if (baseEntry && entry && entry.color) return baseEntry.label + " — " + entry.color;
    return (baseEntry && baseEntry.label) || key;
  }

  function wrapBaseHandle(key) {
    const k = String(key || "");
    const i = k.indexOf("__");
    return i < 0 ? k : k.slice(0, i);
  }

  function wrapIsPlayable(key) {
    const base = wrapBaseHandle(key);
    return !base || base === "none" || !!WRAP_PLAYABLE_BASES[base];
  }

  function wrapIsLaunch(key) {
    return !!WRAP_LAUNCH_BASES[wrapBaseHandle(key)];
  }

  function catalogWrapProducts(catalog) {
    const list = catalog && Array.isArray(catalog.wraps) ? catalog.wraps : [];
    return list.filter(function (p) {
      return p && !productLooksLikeArrowWrap(p);
    });
  }

  function productLooksLikeArrowWrap(product) {
    const hay = [product.handle, product.title, product.type]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return /\barrow\b/.test(hay);
  }

  function wrapKeyFromProduct(product) {
    if (!product) return null;
    const handle = String(product.handle || "")
      .toLowerCase()
      .replace(/-stabilizer-wraps?$/, "")
      .replace(/-wraps?$/, "");
    const title = String(product.title || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
    const keys = Object.keys(WRAP_LAUNCH_BASES);
    let i;
    for (i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (handle === key || handle.indexOf(key + "-") === 0 || handle.indexOf(key) === 0) {
        if (key === "hive" && handle.indexOf("toxic") >= 0) continue;
        if (key === "topo" && (handle.indexOf("deadfall") >= 0 || handle.indexOf("folded") >= 0)) continue;
        return key;
      }
      if (title.indexOf(key) >= 0) {
        if (key === "hive" && title.indexOf("toxic") >= 0) continue;
        if (key === "topo" && (title.indexOf("deadfall") >= 0 || title.indexOf("folded") >= 0)) continue;
        return key;
      }
    }
    return null;
  }

  function wrapProductForKey(catalog, key) {
    const base = wrapBaseHandle(key);
    if (!base || base === "none") return null;
    const list = catalogWrapProducts(catalog);
    let i;
    for (i = 0; i < list.length; i++) {
      if (wrapKeyFromProduct(list[i]) === base) return list[i];
    }
    return null;
  }

  function wrapColorSlug(key) {
    const parts = String(key || "").split("__");
    return parts.length > 1 ? parts.slice(1).join(" ").replace(/-/g, " ") : "";
  }

  function normWrapColor(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/^flo\s+/i, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function wrapColorMatches(hay, want) {
    const h = normWrapColor(hay);
    const w = normWrapColor(want);
    if (!w) return true;
    if (!h) return false;
    if (h === w) return true;
    if (h.indexOf(w) >= 0 || w.indexOf(h) >= 0) return true;
    const tokens = w.split(" ").filter(Boolean);
    const hayTokens = h.split(" ").filter(Boolean);
    return tokens.every(function (t) {
      return hayTokens.indexOf(t) >= 0;
    });
  }

  function wrapLengthsFromProduct(product) {
    const seen = {};
    const out = [];
    (product && product.variants ? product.variants : []).forEach(function (v) {
      const n = parseLen(v);
      if (n && !seen[n]) {
        seen[n] = true;
        out.push(n);
      }
    });
    out.sort(function (a, b) {
      return a - b;
    });
    return out;
  }

  function wrapAvailableLengths(bar, catalog) {
    const modelLens = lengthsFor(bar.model);
    if (!wrapIsLaunch(bar.wrapKey) || bar.wrapKey === "none") return modelLens;
    const product = wrapProductForKey(catalog, bar.wrapKey);
    const wrapLens = wrapLengthsFromProduct(product);
    const allowed = wrapLens.length ? wrapLens : modelLens.filter(function (n) {
      return n <= WRAP_DEFAULT_MAX_IN;
    });
    return modelLens.filter(function (n) {
      return allowed.indexOf(n) >= 0;
    });
  }

  function clampLengthToWrap(bar, catalog) {
    const list = wrapAvailableLengths(bar, catalog);
    if (!list.length) {
      bar.length = clampLength(bar.model, bar.length);
      return bar.length;
    }
    const n = Number(bar.length);
    if (list.indexOf(n) >= 0) return n;
    let best = list[0];
    let i;
    for (i = 0; i < list.length; i++) {
      if (list[i] <= n) best = list[i];
    }
    bar.length = best;
    return best;
  }

  function matchWrapVariant(product, bar) {
    if (!product || !product.variants || !wrapIsLaunch(bar.wrapKey)) return null;
    const wantLen = Number(bar.length);
    const wantColor = wrapColorSlug(bar.wrapKey);
    const atLen = product.variants.filter(function (v) {
      return parseLen(v) === wantLen;
    });
    if (!atLen.length) return null;
    if (wantColor) {
      let i;
      for (i = 0; i < atLen.length; i++) {
        if (wrapColorMatches(optionHay(atLen[i]), wantColor)) return atLen[i];
      }
    }
    if (atLen.length === 1) return atLen[0];
    if (!wantColor) return atLen[0];
    return null;
  }

  function wrapColorsFromProduct(product) {
    if (!product) return [];
    const opts = product.options || [];
    let i;
    for (i = 0; i < opts.length; i++) {
      const name = String(opts[i].name || "").toLowerCase();
      if (name.indexOf("color") >= 0 || name === "colour") {
        return (opts[i].values || []).map(function (value) {
          return String(value);
        });
      }
    }
    const seen = {};
    const out = [];
    (product.variants || []).forEach(function (v) {
      const color = v.option2 || "";
      if (color && color !== v.option1 && !seen[color]) {
        seen[color] = true;
        out.push(color);
      }
    });
    return out;
  }

  function wrapColorHex(colorName, key) {
    const slug = String(key || "").split("__")[1] || "";
    const spaced = slug.replace(/-/g, " ");
    if (spaced && WRAP_COLOR_HEX[spaced]) return WRAP_COLOR_HEX[spaced];
    if (slug && WRAP_COLOR_HEX[slug]) return WRAP_COLOR_HEX[slug];
    const name = String(colorName || "")
      .trim()
      .toLowerCase();
    if (name && WRAP_COLOR_HEX[name]) return WRAP_COLOR_HEX[name];
    if (/^#[0-9a-f]{3,8}$/i.test(name)) return name;
    return "";
  }

  function wrapSwatchLabel(color, key) {
    let text = String(color || "").trim();
    if (!text) {
      const slug = String(key || "").split("__")[1] || "";
      text = slug.replace(/-/g, " ");
    }
    text = text.replace(/^flo\s+/i, "").trim();
    return text.replace(/\b\w/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function isLightHex(hex) {
    const h = String(hex || "").replace("#", "");
    if (h.length < 6) return false;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 168;
  }

  function shortWrapLabel(label, key) {
    let text = String(label || key || "").trim();
    text = text.replace(/\s*\([^)]+\)\s*$/, "").trim();
    return text || String(key || "Wrap");
  }

  function buildWrapIndex(manifest) {
    const wraps = (manifest && manifest.wraps) || {};
    const bases = {};
    const colors = {};
    Object.keys(wraps).forEach(function (k) {
      if (k === "none") return;
      const entry = wraps[k] || {};
      const base = wrapBaseHandle(k);
      if (k.indexOf("__") >= 0) {
        if (!colors[base]) colors[base] = [];
        colors[base].push({
          key: k,
          color: entry.color || k.slice(k.indexOf("__") + 2).replace(/-/g, " "),
          textureUrl: entry.textureUrl,
          thumbUrl: entry.thumbUrl || entry.textureUrl,
          label: entry.label,
          uvIndex: entry.uvIndex,
          uvCount: entry.uvCount,
        });
      } else {
        bases[base] = entry;
      }
    });
    Object.keys(colors).forEach(function (b) {
      colors[b].sort(function (a, c) {
        return String(a.color).localeCompare(String(c.color), undefined, { numeric: true });
      });
      if (!bases[b] && colors[b][0]) {
        const first = colors[b][0];
        bases[b] = {
          label: shortWrapLabel(first.label, b),
          textureUrl: first.textureUrl,
          thumbUrl: first.thumbUrl,
        };
      }
    });
    return { bases: bases, colors: colors, none: wraps.none || { label: "None" } };
  }

  function wrapStripAxis(key) {
    return wrapBaseHandle(key) === "anime" ? "y" : "x";
  }

  function wrapUvFrom(entry, list) {
    if (!entry) return null;
    const file = String(entry.textureUrl || entry.file || "");
    const axis = wrapStripAxis(entry.key || "");
    // Local stab-wrap assets are full-bleed crops; CDN banners may still use uvIndex.
    if (file && !/^https?:\/\//i.test(file) && /stab-wrap-[^/]+\.png/i.test(file)) {
      return { index: 0, count: 1, axis: axis };
    }
    const count = Number(entry.uvCount) || (list && list.length) || 0;
    if (count < 2) return { index: 0, count: 1, axis: axis };
    const index = Number(entry.uvIndex);
    return { index: Number.isFinite(index) ? index : 0, count: count, axis: axis };
  }

  function paintWrapColorSwatch(btn, colorEntry) {
    const hex = wrapColorHex(colorEntry.color, colorEntry.key);
    btn.style.backgroundImage = "none";
    if (hex) {
      btn.style.background = hex;
      btn.textContent = "";
      if (isLightHex(hex)) btn.classList.add("stabilizer-playground__swatch--light");
      return;
    }
    btn.textContent = String(wrapSwatchLabel(colorEntry.color, colorEntry.key) || "").slice(0, 2);
  }

  function defaultColorKey(base, colorList) {
    if (!colorList || !colorList.length) return base;
    return colorList[0].key;
  }

  function thumbUrl(entry, wrapBase) {
    const file = (entry && (entry.thumbUrl || entry.textureUrl)) || "";
    if (!file) return "";
    if (/^https?:\/\//i.test(file)) return file;
    let url = file;
    if (wrapBase) url = wrapBase.replace(/\/$/, "") + "/" + String(file).replace(/^.*\//, "");
    const bust = document.querySelector("[data-wrap-asset-v]")?.getAttribute("data-wrap-asset-v");
    if (bust && url) {
      const join = url.includes("?") ? "&" : "?";
      return `${url}${join}v=${encodeURIComponent(bust)}`;
    }
    return url;
  }

  function applyLaunchWrap(bar, key, entry, list, catalog) {
    bar.wrapKey = key;
    bar.wrapUrl = entry && entry.textureUrl ? entry.textureUrl : null;
    bar.wrapUv = wrapUvFrom(Object.assign({ key: key }, entry || {}), list);
    bar.wrapColor = key === "none" ? null : wrapColorHex((entry && entry.color) || wrapColorSlug(key), key);
    clampLengthToWrap(bar, catalog);
  }

  function appendWrapPicker(box, bar, manifest, wrapBase, refresh, mountNotify, catalog) {
    const index = buildWrapIndex(manifest);
    const wrapSec = document.createElement("div");
    wrapSec.className = "stabilizer-playground__wrap-section";

    const liveHead = document.createElement("div");
    liveHead.className = "stabilizer-playground__section-head";
    const liveTitle = document.createElement("h3");
    liveTitle.className = "stabilizer-playground__wrap-color-title";
    liveTitle.textContent = "Color";
    liveHead.appendChild(liveTitle);
    wrapSec.appendChild(liveHead);

    const liveGrid = document.createElement("div");
    liveGrid.className = "stabilizer-playground__wrap-grid";

    function makeCard(key, entry, multiCount, playable) {
      const card = document.createElement("button");
      card.type = "button";
      card.className =
        "stabilizer-playground__wrap-card" +
        (wrapBaseHandle(bar.wrapKey) === key ? " is-active" : "");
      if (!playable) {
        card.disabled = true;
        card.tabIndex = -1;
        card.setAttribute("aria-disabled", "true");
      }
      const frame = document.createElement("span");
      frame.className = "stabilizer-playground__wrap-thumb-frame";
      const img = document.createElement("img");
      img.className = "stabilizer-playground__wrap-thumb";
      img.alt = "";
      const src = (playable && entry && entry.image) || thumbUrl(entry, wrapBase);
      if (src) img.src = src;
      img.addEventListener("error", function () {
        img.style.display = "none";
      });
      frame.appendChild(img);
      const lab = document.createElement("span");
      lab.className = "stabilizer-playground__wrap-label";
      lab.textContent = shortWrapLabel(entry && entry.label, key);
      card.appendChild(frame);
      card.appendChild(lab);
      if (multiCount > 0) {
        const meta = document.createElement("span");
        meta.className = "stabilizer-playground__wrap-meta";
        meta.textContent = multiCount === 1 ? "1 color" : multiCount + " colors";
        card.appendChild(meta);
      }
      return card;
    }

    function selectBase(base) {
      if (base === "none") {
        applyLaunchWrap(bar, "none", null, null, catalog);
        refresh();
        return;
      }
      const list = index.colors[base] || [];
      const productColors = wrapColorsFromProduct(wrapProductForKey(catalog, base));
      let key = defaultColorKey(base, list);
      if (wrapBaseHandle(bar.wrapKey) === base && bar.wrapKey) key = bar.wrapKey;
      else if (productColors.length && !list.length) {
        key = base + "__" + normWrapColor(productColors[0]).replace(/\s+/g, "-");
      }
      const entry = (manifest.wraps && manifest.wraps[key]) || index.bases[base] || {};
      applyLaunchWrap(bar, key, Object.assign({ key: key }, entry), list, catalog);
      refresh();
    }

    const noneCard = makeCard("none", index.none, 0, true);
    noneCard.addEventListener("click", function () {
      selectBase("none");
    });
    liveGrid.appendChild(noneCard);

    Object.keys(WRAP_LAUNCH_BASES)
      .sort(function (a, b) {
        return shortWrapLabel((index.bases[a] || {}).label, a).localeCompare(
          shortWrapLabel((index.bases[b] || {}).label, b)
        );
      })
      .forEach(function (base) {
        const product = wrapProductForKey(catalog, base);
        const list = index.colors[base] || [];
        const productColors = wrapColorsFromProduct(product);
        const entry = Object.assign({}, index.bases[base] || { label: base });
        if (product && product.image) entry.image = product.image;
        const card = makeCard(base, entry, productColors.length || list.length, true);
        card.addEventListener("click", function () {
          selectBase(base);
        });
        liveGrid.appendChild(card);
      });
    wrapSec.appendChild(liveGrid);

    const selectedBase = wrapBaseHandle(bar.wrapKey);
    if (wrapIsLaunch(selectedBase)) {
      const list = index.colors[selectedBase] || [];
      const product = wrapProductForKey(catalog, selectedBase);
      const productColors = wrapColorsFromProduct(product);
      const colorSwatches = document.createElement("div");
      colorSwatches.className = "stabilizer-playground__wrap-color-swatches";
      function addSwatch(key, url, uv, label, paint) {
        const cell = document.createElement("div");
        cell.className = "stabilizer-playground__swatch-cell";
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className =
          "stabilizer-playground__swatch stabilizer-playground__wrap-color-swatch" +
          ((bar.wrapKey || "none") === key ? " is-active" : "");
        btn.title = label;
        btn.setAttribute("aria-label", label);
        paint(btn);
        btn.addEventListener("click", function () {
          applyLaunchWrap(
            bar,
            key,
            { textureUrl: url, color: label, key: key },
            list,
            catalog
          );
          refresh();
        });
        const cap = document.createElement("span");
        cap.className = "stabilizer-playground__swatch-caption";
        cap.textContent = label;
        cell.appendChild(btn);
        cell.appendChild(cap);
        colorSwatches.appendChild(cell);
      }
      if (list.length) {
        list.forEach(function (c) {
          const label = wrapSwatchLabel(c.color, c.key);
          addSwatch(c.key, c.textureUrl || null, wrapUvFrom(c, list), label, function (btn) {
            paintWrapColorSwatch(btn, c);
          });
        });
      } else if (productColors.length) {
        productColors.forEach(function (colorName) {
          const slug = normWrapColor(colorName).replace(/\s+/g, "-");
          const key = selectedBase + "__" + slug;
          addSwatch(key, (index.bases[selectedBase] || {}).textureUrl || null, null, colorName, function (btn) {
            paintWrapColorSwatch(btn, { color: colorName, key: key });
          });
        });
      }
      if (colorSwatches.children.length) wrapSec.appendChild(colorSwatches);
    }

    // Coming-soon / notify signup removed — launch wraps are for sale.
    box.appendChild(wrapSec);
  }

  function modelLabel(model) {
    return model === "pro" ? "OryX Micro Pro" : "OryX Micro";
  }

  function qdLabel(qd) {
    if (!qd || qd === "none") return "None";
    if (qd === "8") return "8° QD";
    if (qd === "0") return "0° QD";
    if (qd === "rear") return "Rear QD";
    return String(qd);
  }

  function segment(options, value, onChange) {
    const wrap = document.createElement("div");
    wrap.className = "stabilizer-playground__options stabilizer-playground__options--segment";
    options.forEach(function (opt) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "stabilizer-playground__option" + (opt.value === value ? " is-active" : "");
      btn.textContent = opt.label;
      btn.addEventListener("click", function () {
        onChange(opt.value);
      });
      wrap.appendChild(btn);
    });
    return wrap;
  }

  function selectEl(values, value, onChange, suffix) {
    const sel = document.createElement("select");
    sel.className = "stabilizer-playground__select";
    values.forEach(function (v) {
      const opt = document.createElement("option");
      opt.value = String(v);
      opt.textContent = suffix ? v + suffix : String(v);
      if (String(v) === String(value)) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener("change", function () {
      onChange(sel.value);
    });
    return sel;
  }

  function section(title, valueText) {
    const el = document.createElement("section");
    el.className = "stabilizer-playground__section";
    const head = document.createElement("div");
    head.className = "stabilizer-playground__section-head";
    const h2 = document.createElement("h2");
    h2.textContent = title;
    head.appendChild(h2);
    if (valueText) {
      const val = document.createElement("span");
      val.className = "stabilizer-playground__section-value";
      val.textContent = valueText;
      head.appendChild(val);
    }
    el.appendChild(head);
    return el;
  }

  function normalizeBarCoat(bar, raw) {
    bar.color = bar.color || "black";
    if (bar.model === "pro") bar.color = "black";
    if (!raw || raw.lynxColor == null) bar.lynxColor = bar.color;
    if (!raw || raw.flatsColor == null) bar.flatsColor = bar.color;
    bar.colorSplit = !!(raw && raw.colorSplit) || bar.lynxColor !== bar.flatsColor;
    const legacyEnd = validCoat(bar.endColor || bar.color);
    bar.endBowColor = validCoat(bar.endBowColor || legacyEnd);
    bar.endTipColor = validCoat(bar.endTipColor || legacyEnd);
    if (raw && Array.isArray(raw.weightColors)) bar.weightColors = raw.weightColors.slice();
    else if (!Array.isArray(bar.weightColors)) bar.weightColors = [];
    return bar;
  }

  function loadState(fallback) {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return fallback;
      const parsed = JSON.parse(raw);
      return {
        qty: parsed.qty || 1,
        proIncluded: parsed.proIncluded || fallback.proIncluded,
        front: normalizeBarCoat({ ...fallback.front, ...(parsed.front || {}) }, parsed.front),
        rear: normalizeBarCoat({ ...fallback.rear, ...(parsed.rear || {}) }, parsed.rear),
      };
    } catch (e) {
      return fallback;
    }
  }

  function resolveDeepLinkWrapKey(rawWrap, manifest) {
    const wraps = (manifest && manifest.wraps) || {};
    let key = String(rawWrap || "")
      .trim()
      .toLowerCase()
      .replace(/^awrap-/, "")
      .replace(/^stab-wrap-/, "");
    if (!key || key === "none") return null;
    if (wraps[key]) return key;
    const base = wrapBaseHandle(key);
    const colorSlug = wrapColorSlug(key);
    if (colorSlug) {
      const withColor = base + "__" + colorSlug.replace(/\s+/g, "-");
      if (wraps[withColor]) return withColor;
    }
    if (WRAP_LAUNCH_BASES[base]) {
      const colors = Object.keys(wraps).filter(function (k) {
        return wrapBaseHandle(k) === base && k.indexOf("__") >= 0;
      });
      if (colorSlug) {
        let i;
        for (i = 0; i < colors.length; i++) {
          if (wrapColorMatches(wrapColorSlug(colors[i]), colorSlug)) return colors[i];
        }
      }
      if (wraps[base]) return base;
      if (colors[0]) return colors[0];
      return base;
    }
    return null;
  }

  function applyBuilderDeepLink(state, manifest, catalog) {
    let params;
    try {
      params = new URLSearchParams(window.location.search || "");
    } catch (e) {
      return state;
    }
    const wrapParam = params.get("wrap");
    const lengthParam = params.get("length");
    if (wrapParam) {
      const key = resolveDeepLinkWrapKey(wrapParam, manifest);
      if (key && wrapIsLaunch(key)) {
        const entry = (manifest.wraps && manifest.wraps[key]) || {};
        const list = ((buildWrapIndex(manifest).colors || {})[wrapBaseHandle(key)]) || [];
        applyLaunchWrap(state.front, key, Object.assign({ key: key }, entry), list, catalog);
      }
    }
    if (lengthParam) {
      const len = clampLength(state.front.model, Number(lengthParam));
      if (len) {
        state.front.length = len;
        clampLengthToWrap(state.front, catalog);
      }
    }
    return state;
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
  }

  function buildCartItems(state, catalog, manifest) {
    const items = [];
    const buildId = "spg_" + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36);
    const qty = Math.max(1, Number(state.qty) || 1);
    const proIncluded = state.proIncluded;
    const unavailable = [];

    function pushVariant(variant, quantity, props) {
      if (!variant) return;
      if (!variant.available) {
        unavailable.push(variant.title || "Unavailable item");
        return;
      }
      items.push({
        id: variant.id,
        quantity: quantity,
        properties: props,
      });
    }

    function barProduct(bar) {
      return bar.model === "pro" ? catalog.microPro : catalog.micro;
    }

    function extrasFor(bar, props) {
      const extra = extraCharges(bar, proIncluded);
      if (extra.extraLynxOz > 0 && catalog.lynx) {
        const v = (catalog.lynx.variants || []).find(function (x) {
          const hay = optionHay(x);
          return hay.indexOf("1oz") >= 0 && hay.indexOf("cap") < 0;
        });
        pushVariant(v || catalog.lynx.variants[0], extra.extraLynxOz * qty, props);
      }
      if (extra.needCap && catalog.lynx) {
        const cap = (catalog.lynx.variants || []).find(function (x) {
          return optionHay(x).indexOf("cap") >= 0;
        });
        pushVariant(cap, qty, props);
      }
      if (extra.extraFlatsOz > 0 && catalog.flats) {
        let remain = extra.extraFlatsOz;
        const two = (catalog.flats.variants || []).find(function (x) {
          return /2\s*oz/.test(optionHay(x));
        });
        const one = (catalog.flats.variants || []).find(function (x) {
          return /1\s*oz/.test(optionHay(x));
        });
        if (two && remain >= 2) {
          const n = Math.floor(remain / 2);
          pushVariant(two, n * qty, props);
          remain -= n * 2;
        }
        if (remain > 0) pushVariant(one || catalog.flats.variants[0], remain * qty, props);
      }
    }

    const frontOz = barOz(state.front, proIncluded);
    const rearOz = state.rear.enabled ? barOz(state.rear, proIncluded) : 0;
    const properties = {
      _build_id: buildId,
      _build_kind: "stabilizer",
      Front: modelLabel(state.front.model) + " " + state.front.length + '" ' + colorLabel(state.front.color),
      "Front included": includedFor(state.front, proIncluded),
      "Front weights": weightColorList(state.front, proIncluded),
      "Front stabilizer start": colorLabel(state.front.endBowColor || state.front.endColor || state.front.color),
      "Front stabilizer end": colorLabel(state.front.endTipColor || state.front.endColor || state.front.color),
      "Front QD": qdLabel(state.front.qd),
      Rear: state.rear.enabled
        ? modelLabel(state.rear.model) + " " + state.rear.length + '" ' + colorLabel(state.rear.color)
        : "None",
      "Rear weights": state.rear.enabled ? weightColorList(state.rear, proIncluded) : "None",
      "Rear stabilizer start": state.rear.enabled
        ? colorLabel(state.rear.endBowColor || state.rear.endColor || state.rear.color)
        : "None",
      "Rear stabilizer end": state.rear.enabled
        ? colorLabel(state.rear.endTipColor || state.rear.endColor || state.rear.color)
        : "None",
      "Rear QD": state.rear.enabled ? qdLabel(state.rear.qd) : "None",
      "Front oz": formatOz(frontOz),
      "Rear oz": formatOz(rearOz),
      "Total oz": formatOz(frontOz + rearOz),
    };

    const frontVar = matchBarVariant(barProduct(state.front), state.front, proIncluded);
    if (!frontVar) throw new Error("OryX bar product is not assigned in the theme editor.");
    pushVariant(frontVar, qty, properties);
    extrasFor(state.front, { _build_id: buildId, _build_kind: "stabilizer" });

    if (state.front.qd && state.front.qd !== "none") {
      const qdProd = state.front.qd === "8" ? catalog.frontQd8 : catalog.frontQd0;
      const qdVar = qdProd && qdProd.variants && qdProd.variants[0];
      pushVariant(qdVar, qty, { _build_id: buildId, _build_kind: "stabilizer" });
      if (!qdVar) unavailable.push("Front quick disconnect");
    }

    if (state.rear.enabled) {
      const rearVar = matchBarVariant(barProduct(state.rear), state.rear, proIncluded);
      if (!rearVar) throw new Error("Rear OryX bar product is not assigned.");
      pushVariant(rearVar, qty, { _build_id: buildId, _build_kind: "stabilizer" });
      extrasFor(state.rear, { _build_id: buildId, _build_kind: "stabilizer" });
      if (state.rear.qd && state.rear.qd !== "none") {
        const qdVar = catalog.rearQd && catalog.rearQd.variants && catalog.rearQd.variants[0];
        pushVariant(qdVar, qty, { _build_id: buildId, _build_kind: "stabilizer" });
        if (!qdVar) unavailable.push("Rear quick disconnect");
      }
    }

    function wrapLaborVariant() {
      const prod = catalog.wrapInstallLabor;
      if (!prod || !prod.variants || !prod.variants.length) return null;
      const available = prod.variants.filter(function (v) {
        return v.available !== false && v.id;
      });
      return available[0] || prod.variants[0] || null;
    }

    function pushWrapFor(bar, slotLabel) {
      if (!wrapIsLaunch(bar.wrapKey) || bar.wrapKey === "none") return;
      const product = wrapProductForKey(catalog, bar.wrapKey);
      const name = wrapLabel(manifest, bar.wrapKey);
      if (!product) {
        unavailable.push(slotLabel + " " + name + " — stabilizer wrap product is not assigned (not an arrow wrap)");
        return;
      }
      const variant = matchWrapVariant(product, bar);
      if (!variant) {
        unavailable.push(slotLabel + " " + name + " is not sold in " + bar.length + '"');
        return;
      }
      pushVariant(variant, qty, {
        _build_id: buildId,
        _build_kind: "stabilizer",
        Bar: slotLabel,
        "Wrap note": "Sized up to 20 in; may need trimming for some lengths",
      });
      const labor = wrapLaborVariant();
      if (!labor) {
        unavailable.push(slotLabel + " wrap install labor — product is not assigned ($10/bar)");
        return;
      }
      pushVariant(labor, qty, {
        _build_id: buildId,
        _build_kind: "stabilizer",
        Bar: slotLabel,
        Wraps: name,
        "Wrap Labor": "Install per bar ($10)",
      });
    }
    pushWrapFor(state.front, "Front");
    if (state.rear.enabled) pushWrapFor(state.rear, "Rear");

    return { items: items, buildId: buildId, unavailable: unavailable };
  }

  function buildHasWrap(state) {
    if (wrapIsLaunch(state.front.wrapKey) && state.front.wrapKey !== "none") return true;
    return !!(
      state.rear.enabled &&
      wrapIsLaunch(state.rear.wrapKey) &&
      state.rear.wrapKey !== "none"
    );
  }

  function syncWrapTrimAck(root, state) {
    const ack = $(root, "[data-stabilizer-wrap-trim-ack]");
    const input = $(root, "[data-stabilizer-wrap-trim-ack-input]");
    if (!ack) return true;
    const needed = buildHasWrap(state);
    ack.hidden = !needed;
    if (!needed) {
      ack.classList.remove("is-error");
      if (input) input.checked = false;
      return true;
    }
    return !!(input && input.checked);
  }

  function confirmWrapTrimIfNeeded(root, state) {
    if (!buildHasWrap(state)) return true;
    const ack = $(root, "[data-stabilizer-wrap-trim-ack]");
    const input = $(root, "[data-stabilizer-wrap-trim-ack-input]");
    if (input && input.checked) {
      if (ack) ack.classList.remove("is-error");
      return true;
    }
    if (ack) {
      ack.hidden = false;
      ack.classList.add("is-error");
      if (input) {
        input.focus();
        try {
          input.scrollIntoView({ block: "nearest", behavior: "smooth" });
        } catch (e) {}
      }
    }
    return false;
  }

  function priceOf(variant) {
    return variant && variant.available !== false ? Number(variant.price) || 0 : 0;
  }

  function estimatePrice(state, catalog) {
    let cents = 0;
    const qty = Math.max(1, Number(state.qty) || 1);
    function add(v, n) {
      if (v) cents += priceOf(v) * n;
    }
    function extras(bar) {
      const extra = extraCharges(bar, state.proIncluded);
      if (extra.extraLynxOz && catalog.lynx) {
        const v = (catalog.lynx.variants || []).find(function (x) {
          return /1oz/.test(optionHay(x)) && optionHay(x).indexOf("cap") < 0;
        });
        add(v, extra.extraLynxOz * qty);
      }
      if (extra.needCap && catalog.lynx) {
        const cap = (catalog.lynx.variants || []).find(function (x) {
          return optionHay(x).indexOf("cap") >= 0;
        });
        add(cap, qty);
      }
      if (extra.extraFlatsOz && catalog.flats) {
        const one = (catalog.flats.variants || []).find(function (x) {
          return /1\s*oz/.test(optionHay(x));
        });
        add(one || (catalog.flats.variants || [])[0], extra.extraFlatsOz * qty);
      }
    }
    add(matchBarVariant(state.front.model === "pro" ? catalog.microPro : catalog.micro, state.front, state.proIncluded), qty);
    extras(state.front);
    if (state.front.qd === "8") add(catalog.frontQd8 && catalog.frontQd8.variants && catalog.frontQd8.variants[0], qty);
    else if (state.front.qd && state.front.qd !== "none") {
      add(catalog.frontQd0 && catalog.frontQd0.variants && catalog.frontQd0.variants[0], qty);
    }
    if (state.rear.enabled) {
      add(matchBarVariant(state.rear.model === "pro" ? catalog.microPro : catalog.micro, state.rear, state.proIncluded), qty);
      extras(state.rear);
      if (state.rear.qd && state.rear.qd !== "none") {
        add(catalog.rearQd && catalog.rearQd.variants && catalog.rearQd.variants[0], qty);
      }
    }
    function addWrap(bar) {
      if (!wrapIsLaunch(bar.wrapKey) || bar.wrapKey === "none") return;
      add(matchWrapVariant(wrapProductForKey(catalog, bar.wrapKey), bar), qty);
      const laborProd = catalog.wrapInstallLabor;
      if (laborProd && laborProd.variants && laborProd.variants.length) {
        const available = laborProd.variants.filter(function (v) {
          return v.available !== false && v.id;
        });
        add(available[0] || laborProd.variants[0], qty);
      }
    }
    addWrap(state.front);
    if (state.rear.enabled) addWrap(state.rear);
    return cents;
  }

  function init(root) {
    const catalog = parseCatalog(root);
    const wrapBase = root.getAttribute("data-wrap-texture-base") || "";
    const wrapAssetV = root.getAttribute("data-wrap-asset-v") || "";
    const modelSrc = root.getAttribute("data-model-src") || "";
    const endGlbSrc = root.getAttribute("data-end-glb") || "";
    const proIncluded = root.getAttribute("data-pro-included") || "lynx";
    const manifestUrl = SHOW_WRAP_PICKER ? root.getAttribute("data-wraps-manifest") || "" : "";

    const start = function (manifest) {
      root._stabWraps = manifest || { wraps: { none: { label: "None" } } };
      initReady(root, catalog, root._stabWraps, wrapBase, wrapAssetV, modelSrc, endGlbSrc, proIncluded);
    };

    if (!manifestUrl) {
      start({ wraps: { none: { label: "None" } } });
      return;
    }
    fetch(manifestUrl)
      .then(function (res) {
        return res.ok ? res.json() : { wraps: { none: { label: "None" } } };
      })
      .then(start)
      .catch(function () {
        start({ wraps: { none: { label: "None" } } });
      });
  }

  function initReady(root, catalog, manifest, wrapBase, wrapAssetV, modelSrc, endGlbSrc, proIncluded) {
    let state = loadState(defaultState(proIncluded));
    state.proIncluded = proIncluded;
    state.front.length = clampLength(state.front.model, state.front.length);
    state.rear.length = clampLength(state.rear.model, state.rear.length);
    clampLengthToWrap(state.front, catalog);
    clampLengthToWrap(state.rear, catalog);
    applyBuilderDeepLink(state, manifest, catalog);
    ["front", "rear"].forEach(function (slot) {
      if (SHOW_WRAP_PICKER && wrapIsPlayable(state[slot].wrapKey)) {
        const bar = state[slot];
        if (bar.wrapKey && bar.wrapKey !== "none" && !bar.wrapColor) {
          bar.wrapColor = wrapColorHex("", bar.wrapKey);
        }
        return;
      }
      state[slot].wrapKey = "none";
      state[slot].wrapUrl = null;
      state[slot].wrapUv = null;
      state[slot].wrapColor = null;
    });
    syncWeightColors(state.front, state.proIncluded);
    syncWeightColors(state.rear, state.proIncluded);

    const host = $(root, "[data-stabilizer-playground-host]");
    const controlsEl = $(root, "[data-stabilizer-playground-controls]");
    const priceEl = $(root, "[data-stabilizer-playground-price]");
    const errorEl = $(root, "[data-stabilizer-playground-error]");
    const atcBtn = $(root, "[data-stabilizer-playground-atc]");
    const qtyInput = $(root, "[data-stabilizer-playground-qty]");
    const frontOzEl = $(root, "[data-stabilizer-front-oz]");
    const rearOzEl = $(root, "[data-stabilizer-rear-oz]");
    const totalOzEl = $(root, "[data-stabilizer-total-oz]");
    const fabRear = $(root, '[data-stabilizer-fab="rear"]');
    const fabSpin = $(root, '[data-stabilizer-fab="spin"]');
    const fabExport = $(root, '[data-stabilizer-fab="export"]');

    const createViewer =
      window.StabilizerViewer && window.StabilizerViewer.createStabilizerViewer;
    if (!createViewer && host) {
      host.innerHTML = "<p class=\"stabilizer-playground__hint\">3D viewer did not load.</p>";
    }
    const viewer = createViewer
      ? createViewer(host, {
          modelSrc: modelSrc,
          endGlbSrc: endGlbSrc,
          riserGlbSrc: root.getAttribute("data-riser-glb") || "",
          logoSrc: root.getAttribute("data-logo-src") || "",
          qdGlbSrc: {
            0: root.getAttribute("data-qd-0-glb") || "",
            8: root.getAttribute("data-qd-8-glb") || "",
            rear: root.getAttribute("data-qd-rear-glb") || "",
          },
          wrapTextureBaseUrl: wrapBase,
          wrapAssetV: wrapAssetV,
          poseEdit: root.hasAttribute("data-pose-edit"),
          initialState: { front: state.front, rear: state.rear },
        })
      : null;
    if (fabExport) fabExport.disabled = true;
    if (viewer) {
      viewer.ready
        .then(function () {
          if (fabExport) fabExport.disabled = false;
        })
        .catch(function (err) {
          console.warn("[Stabilizer playground] viewer failed", err);
        });
    }

    function syncFabs() {
      if (fabRear) fabRear.disabled = !state.rear.enabled;
    }

    function setSpinUi(on) {
      if (!fabSpin) return;
      fabSpin.setAttribute("aria-pressed", on ? "true" : "false");
      fabSpin.title = on ? "Stop spin" : "Spin around riser";
      fabSpin.setAttribute("aria-label", on ? "Stop spinning around the riser" : "Spin around the riser");
    }

    function zoomTo(slot) {
      if (!viewer || (slot === "rear" && !state.rear.enabled)) return;
      viewer.focus({ slot: slot, part: "bar" });
      setSpinUi(false);
    }

    function oryxSlug(bar) {
      return (bar.model === "pro" ? "pro" : "micro") + "-" + bar.length;
    }

    function exportPreview() {
      if (!viewer || !viewer.exportPng || !fabExport || fabExport.disabled) return;
      const rear = state.rear.enabled ? "rear-" + oryxSlug(state.rear) : "rear-off";
      const name =
        "titlex-oryx-front-" + oryxSlug(state.front) + "-" + rear + "-" + new Date().toISOString().slice(0, 10) + ".png";
      fabExport.disabled = true;
      Promise.resolve(viewer.exportPng(name))
        .catch(function (err) {
          console.warn("[Stabilizer playground] PNG export failed", err);
        })
        .then(function () {
          fabExport.disabled = false;
        });
    }

    root.querySelectorAll("[data-stabilizer-fab]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const action = btn.getAttribute("data-stabilizer-fab");
        if (action === "reset") {
          if (viewer) viewer.resetCamera();
          setSpinUi(false);
        } else if (action === "spin") {
          if (!viewer || !viewer.toggleSpin) return;
          setSpinUi(viewer.toggleSpin());
        } else if (action === "export") {
          exportPreview();
        } else if (action === "front" || action === "rear") {
          zoomTo(action);
        }
      });
    });

    function barForViewer(bar) {
      syncWeightColors(bar, state.proIncluded);
      return Object.assign({}, bar, {
        included: includedFor(bar, state.proIncluded),
        weightColors: (bar.weightColors || []).slice(),
      });
    }

    function syncViewer(focus) {
      if (!viewer) return;
      const done = viewer.setState({ front: barForViewer(state.front), rear: barForViewer(state.rear) });
      if (focus && viewer.focus) {
        Promise.resolve(done).then(function () {
          viewer.focus(focus);
          setSpinUi(false);
        });
      }
    }

    function renderStats() {
      const f = barOz(state.front, state.proIncluded);
      const r = state.rear.enabled ? barOz(state.rear, state.proIncluded) : 0;
      if (frontOzEl) frontOzEl.textContent = formatOz(f);
      if (rearOzEl) rearOzEl.textContent = state.rear.enabled ? formatOz(r) : "—";
      if (totalOzEl) totalOzEl.textContent = formatOz(f + r);
      if (priceEl) priceEl.textContent = formatMoney(estimatePrice(state, catalog), catalog.moneyFormat);
      if (qtyInput) qtyInput.value = String(state.qty);
      syncWrapTrimAck(root, state);
    }

    function renderBar(slot) {
      const bar = state[slot];
      const box = section(slot === "front" ? "Front bar" : "Rear bar", modelLabel(bar.model));
      if (slot === "rear") {
        const toggle = segment(
          [
            { value: "on", label: "On" },
            { value: "off", label: "Off" },
          ],
          bar.enabled ? "on" : "off",
          function (v) {
            bar.enabled = v === "on";
            refresh(v === "on" ? { slot: "rear", part: "qd" } : { part: "overview" });
          }
        );
        box.appendChild(toggle);
        if (!bar.enabled) return box;
      }

      box.appendChild(
        segment(
          [
            { value: "micro", label: "Micro" },
            { value: "pro", label: "Micro Pro" },
          ],
          bar.model,
          function (v) {
            bar.model = v;
            bar.length = clampLength(v, bar.length);
            clampLengthToWrap(bar, catalog);
            if (v === "pro") {
              bar.color = "black";
              bar.lynxColor = "black";
              bar.flatsColor = "black";
              bar.colorSplit = false;
              bar.weightColors = [];
            }
            refresh();
          }
        )
      );

      const lenHead = document.createElement("p");
      lenHead.className = "stabilizer-playground__section-value";
      lenHead.textContent = "Length";
      box.appendChild(lenHead);
      box.appendChild(
        selectEl(
          wrapAvailableLengths(bar, catalog),
          bar.length,
          function (v) {
            bar.length = Number(v);
            clampLengthToWrap(bar, catalog);
            refresh();
          },
          '"'
        )
      );

      if (bar.model === "micro") {
        box.appendChild(
          segment(
            [
              { value: "lynx", label: "3oz LynX" },
              { value: "flats", label: "3oz Flats" },
            ],
            includedFor(bar, state.proIncluded),
            function (v) {
              bar.included = v;
              refresh();
            }
          )
        );
      }

      const extras = document.createElement("div");
      extras.className = "stabilizer-playground__extras";
      const flatsLab = document.createElement("label");
      flatsLab.textContent = "Extra flats (oz)";
      extras.appendChild(flatsLab);
      extras.appendChild(
        selectEl([0, 1, 2, 3, 4, 6, 8], bar.extraFlatsOz, function (v) {
          bar.extraFlatsOz = Number(v);
          refresh();
        })
      );
      const lynxLab = document.createElement("label");
      lynxLab.textContent = "Extra LynX (oz)";
      extras.appendChild(lynxLab);
      extras.appendChild(
        selectEl([0, 1, 2, 3, 4, 6], bar.extraLynxOz, function (v) {
          bar.extraLynxOz = Number(v);
          refresh();
        })
      );
      box.appendChild(extras);

      const endBox = document.createElement("div");
      endBox.className = "stabilizer-playground__weight-pieces";
      endBox.appendChild(
        coatRow(
          "Stabilizer start",
          validCoat(bar.endBowColor || bar.endColor || bar.color),
          function (key) {
            bar.endBowColor = key;
            refresh({ slot: slot, part: "start" });
          },
          true
        )
      );
      endBox.appendChild(
        coatRow(
          "Stabilizer end",
          validCoat(bar.endTipColor || bar.endColor || bar.color),
          function (key) {
            bar.endTipColor = key;
            refresh({ slot: slot, part: "end" });
          },
          true
        )
      );
      box.appendChild(endBox);

      if (bar.model !== "pro") {
        const pieces = syncWeightColors(bar, state.proIncluded);
        if (pieces.length) {
          const pieceBox = document.createElement("div");
          pieceBox.className = "stabilizer-playground__weight-pieces";
          pieces.forEach(function (_piece, i) {
            pieceBox.appendChild(
              coatRow(
                "Weight " + (i + 1),
                bar.weightColors[i] || bar.color,
                function (key) {
                  bar.weightColors[i] = key;
                  refresh({ slot: slot, part: "weights" });
                },
                true
              )
            );
          });
          box.appendChild(pieceBox);
        }
      }

      const qdOpts =
        slot === "front"
          ? [
              { value: "0", label: "QD 0°" },
              { value: "8", label: "QD 8°" },
              { value: "none", label: "No QD" },
            ]
          : [
              { value: "rear", label: "Rear QD" },
              { value: "none", label: "No QD" },
            ];
      box.appendChild(
        segment(qdOpts, bar.qd, function (v) {
          bar.qd = v;
          refresh({ slot: slot, part: "qd" });
        })
      );

      if (SHOW_WRAP_PICKER) {
        appendWrapPicker(box, bar, manifest, wrapBase, refresh, null, catalog);
      }
      return box;
    }

    function wrapNotifyPark() {
      let park = root.querySelector("[data-stab-wrap-notify-park]");
      if (!park) {
        park = document.createElement("div");
        park.setAttribute("data-stab-wrap-notify-park", "");
        park.hidden = true;
        root.appendChild(park);
      }
      const host = root.querySelector("[data-stab-wrap-notify]");
      if (host && host.parentNode !== park) park.appendChild(host);
    }

    function buildLocalWrapNotifyForm() {
      const form = document.createElement("form");
      form.className = "stabilizer-playground__wrap-notify-form";
      form.setAttribute("data-stab-wrap-notify-local", "");
      const tag = document.createElement("input");
      tag.type = "hidden";
      tag.name = "contact[tags]";
      tag.value = "stab-builder-notify";
      const field = document.createElement("div");
      field.className = "stabilizer-playground__wrap-notify-fields";
      const email = document.createElement("input");
      email.type = "email";
      email.name = "contact[email]";
      email.className = "stabilizer-playground__wrap-notify-email";
      email.placeholder = "Email";
      email.setAttribute("aria-label", "Email");
      email.autocomplete = "email";
      email.required = true;
      const submit = document.createElement("button");
      submit.type = "submit";
      submit.className = "stabilizer-playground__wrap-notify-submit";
      submit.textContent = "Notify me";
      field.appendChild(email);
      field.appendChild(submit);
      const success = document.createElement("p");
      success.className = "stabilizer-playground__wrap-notify-success";
      success.setAttribute("data-stab-wrap-notify-success", "");
      success.hidden = true;
      success.setAttribute("role", "status");
      form.appendChild(tag);
      form.appendChild(field);
      form.appendChild(success);
      return form;
    }

    function ensureWrapNotifyHost() {
      let host = root.querySelector("[data-stab-wrap-notify]");
      if (host) return host;
      const park = root.querySelector("[data-stab-wrap-notify-park]");
      host = document.createElement("div");
      host.className = "stabilizer-playground__wrap-notify";
      host.setAttribute("data-stab-wrap-notify", "");
      const toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "stabilizer-playground__wrap-notify-toggle";
      toggle.setAttribute("data-stab-wrap-notify-toggle", "");
      toggle.setAttribute("aria-expanded", "false");
      toggle.textContent = "Sign up to be notified when we are selling wraps";
      const panel = document.createElement("div");
      panel.className = "stabilizer-playground__wrap-notify-panel";
      panel.setAttribute("data-stab-wrap-notify-panel", "");
      panel.hidden = true;
      const parkedForm = park && park.querySelector("form");
      panel.appendChild(parkedForm || buildLocalWrapNotifyForm());
      host.appendChild(toggle);
      host.appendChild(panel);
      (park || root).appendChild(host);
      wireWrapNotify(host);
      return host;
    }

    function wireWrapNotify(host) {
      if (host._stabNotifyWired) return;
      host._stabNotifyWired = true;
      const toggle = host.querySelector("[data-stab-wrap-notify-toggle]");
      const panel = host.querySelector("[data-stab-wrap-notify-panel]");
      const form = host.querySelector("form");
      function setOpen(open) {
        host.classList.toggle("is-open", open);
        if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (panel) panel.hidden = !open;
      }
      const keepOpen =
        !!(form && form.querySelector("[data-stab-wrap-notify-success]:not([hidden])")) ||
        !!(form && form.querySelector("[data-stab-wrap-notify-error]"));
      if (keepOpen) setOpen(true);
      if (toggle) {
        toggle.addEventListener("click", function () {
          const open = !host.classList.contains("is-open");
          setOpen(open);
          if (open) {
            const email = host.querySelector('input[type="email"]');
            if (email) email.focus();
          }
        });
      }
      if (form && form.hasAttribute("data-stab-wrap-notify-local")) {
        form.addEventListener("submit", function (ev) {
          ev.preventDefault();
          const fields = form.querySelector(".stabilizer-playground__wrap-notify-fields");
          const success = form.querySelector("[data-stab-wrap-notify-success]");
          if (fields) fields.hidden = true;
          if (success) {
            success.hidden = false;
            success.textContent = "Thanks — we’ll email you when wraps go on sale.";
          }
          setOpen(true);
        });
      }
    }

    function wrapNotifyMount(soon) {
      if (!soon) return;
      soon.appendChild(ensureWrapNotifyHost());
    }

    function renderControls() {
      wrapNotifyPark();
      controlsEl.innerHTML = "";
      controlsEl.appendChild(renderBar("front"));
      controlsEl.appendChild(renderBar("rear"));
    }

    function refresh(focus) {
      syncWeightColors(state.front, state.proIncluded);
      syncWeightColors(state.rear, state.proIncluded);
      saveState(state);
      renderControls();
      renderStats();
      syncViewer(focus);
      syncFabs();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }
    }

    root.querySelectorAll("[data-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const dir = btn.getAttribute("data-qty") === "-" ? -1 : 1;
        state.qty = Math.max(1, Math.min(6, (Number(state.qty) || 1) + dir));
        refresh();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        state.qty = Math.max(1, Math.min(6, Number(qtyInput.value) || 1));
        refresh();
      });
    }

    function refreshCartDrawer(openDrawer) {
      const cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || typeof window.routes === "undefined") return Promise.resolve();
      return fetch(window.routes.cart_url + "?section_id=cart-drawer")
        .then(function (res) {
          return res.text();
        })
        .then(function (htmlText) {
          if (typeof window.applyCartDrawerSectionHtml === "function") {
            window.applyCartDrawerSectionHtml(htmlText);
          }
          if (openDrawer !== false && typeof cartDrawer.open === "function") cartDrawer.open();
        });
    }

    function refreshCartIconBubble() {
      if (typeof window.routes === "undefined") return Promise.resolve();
      return fetch(window.routes.cart_url + "?section_id=cart-icon-bubble")
        .then(function (res) {
          return res.text();
        })
        .then(function (htmlText) {
          const html = new DOMParser().parseFromString(htmlText, "text/html");
          const sourceSection =
            html.querySelector("#shopify-section-cart-icon-bubble") || html.querySelector(".shopify-section");
          const target = document.querySelector("#cart-icon-bubble");
          if (sourceSection && target) target.innerHTML = sourceSection.innerHTML;
        });
    }

    const wrapTrimInput = $(root, "[data-stabilizer-wrap-trim-ack-input]");
    if (wrapTrimInput) {
      wrapTrimInput.addEventListener("change", function () {
        const ack = $(root, "[data-stabilizer-wrap-trim-ack]");
        if (ack && wrapTrimInput.checked) ack.classList.remove("is-error");
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener("click", function () {
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = "";
        }
        if (!confirmWrapTrimIfNeeded(root, state)) return;
        let packed;
        try {
          packed = buildCartItems(state, catalog, manifest);
        } catch (err) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = err.message || "Could not build cart.";
          }
          return;
        }
        if (!packed.items.length) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = "Assign stabilizer products in the theme editor to enable Add to cart.";
          }
          return;
        }
        if (packed.unavailable.length) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent =
              "Unavailable: " + packed.unavailable.join(", ") + ". 3D preview is unchanged.";
          }
        }
        atcBtn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: packed.items }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || "Cart add failed");
              return data;
            });
          })
          .then(function (data) {
            return Promise.all([refreshCartDrawer(true), refreshCartIconBubble()]).then(function () {
              return data;
            });
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message || "Could not add to cart.";
            }
          })
          .finally(function () {
            atcBtn.disabled = false;
          });
      });
    }

    renderControls();
    renderStats();
    syncFabs();
    syncViewer();
  }

  function boot() {
    document.querySelectorAll("[data-stabilizer-playground]").forEach(init);
  }

  if (window.StabilizerViewer) boot();
  else window.addEventListener("stabilizer-viewer-ready", boot);
})();
